import "../assets/common3.css";
import { c as a } from "./index.bddf5ebb.js";
const _ = "_modal_1ajoo_1", t = "_visual_1ajoo_5", i = "_image_1ajoo_12", e = "_isPlaying_1ajoo_18", l = "_playButton_1ajoo_22", c = "_iconWrapper_1ajoo_40", r = "_video_1ajoo_77", d = "_header_1ajoo_93", y = "_content_1ajoo_98", m = "_body_1ajoo_103", u = "_footer_1ajoo_108", j = "_visualOnly_1ajoo_112", v = "_dismiss_1ajoo_133", o = {
  modal: _,
  visual: t,
  image: i,
  isPlaying: e,
  playButton: l,
  iconWrapper: c,
  video: r,
  header: d,
  content: y,
  body: m,
  footer: u,
  visualOnly: j,
  dismiss: v
}, f = ({
  className: s,
  isVisualOnly: n
}) => a([
  o.modal,
  s,
  {
    [o.visualOnly || ""]: !!n
  }
]), O = ({ isPlaying: s }) => a([
  o.visual,
  {
    [o.isPlaying || ""]: !!s
  }
]);
export {
  f as c,
  o as s,
  O as v
};
//# sourceMappingURL=common.2f376a27.js.map
